import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#f5f4f0',fontFamily:'sans-serif'}}>
      <div style={{background:'#fff',border:'0.5px solid rgba(0,0,0,0.1)',borderRadius:'16px',padding:'2.5rem',width:'100%',maxWidth:'400px'}}>
        <div style={{fontSize:'18px',fontWeight:'600',marginBottom:'1.5rem'}}>SellerDash</div>
        <h1 style={{fontSize:'22px',fontWeight:'500',margin:'0 0 1.5rem'}}>Sign in</h1>
        {error && <div style={{background:'#fef2f2',color:'#991b1b',borderRadius:'8px',padding:'10px 12px',fontSize:'13px',marginBottom:'1rem'}}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <label style={{display:'block',fontSize:'12px',fontWeight:'500',color:'#555',marginBottom:'4px'}}>Email</label>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
            style={{width:'100%',padding:'9px 12px',border:'0.5px solid #ddd',borderRadius:'8px',fontSize:'14px',marginBottom:'1rem',boxSizing:'border-box'}} />
          <label style={{display:'block',fontSize:'12px',fontWeight:'500',color:'#555',marginBottom:'4px'}}>Password</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} required
            style={{width:'100%',padding:'9px 12px',border:'0.5px solid #ddd',borderRadius:'8px',fontSize:'14px',marginBottom:'1.25rem',boxSizing:'border-box'}} />
          <button type="submit" disabled={loading}
            style={{width:'100%',padding:'11px',background:'#1a1a1a',color:'#fff',border:'none',borderRadius:'8px',fontSize:'14px',fontWeight:'500',cursor:'pointer'}}>
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>
        <p style={{fontSize:'13px',color:'#666',marginTop:'1.25rem',textAlign:'center'}}>
          No account? <Link to="/register" style={{color:'#1a1a1a',fontWeight:'500'}}>Start free trial</Link>
        </p>
      </div>
    </div>
  );
}